import { render } from "./PurpleButton.vue?vue&type=template&id=d66fea9a&scoped=true"
import script from "./PurpleButton.vue?vue&type=script&lang=js"
export * from "./PurpleButton.vue?vue&type=script&lang=js"

import "@/assets/css/essayWriting.sass?vue&type=style&index=0&id=d66fea9a&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d66fea9a"]])

export default __exports__